/*@ngInject*/
const RedeployRuleSetsController = function ($rootScope, $scope, localization, coreConstant, dataSetUtil, options) {

    var translations;

    $scope.viewModel = {
        ruleSetItemList: [],
        selectAll: '',
        selectAllCheckbox: false
    };

    localization.getTranslationByKey('redeployRuleSets').then(function (result) {
        var submissionUri = null,
            variableName = null,
            ruleSetsDataSetName,
            dataSetParams = null;

        translations = result;

        ruleSetsDataSetName = translations.ruleSetsDataSetName;
        dataSetParams = dataSetUtil.getDataSetParamsByName(ruleSetsDataSetName, variableName, submissionUri);

        $scope.viewModel.selectAll = translations.selectAll;

        function processDataItems(dataItems) {
            $scope.viewModel.ruleSetItemList = [];
            _.each(dataItems, function (dataItem) {
                var selected = options.defaultRuleSetId && options.defaultRuleSetId === parseInt(dataItem.value) ? true : false;
                $scope.viewModel.ruleSetItemList.push({
                    label: dataItem.name,
                    ruleSetId: dataItem.value,
                    selected: selected
                });
            });
        }

        dataSetUtil.getDataItems(dataSetParams).then(processDataItems);
    });

    $scope.onSelectAll = function () {
        _.each($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
            ruleSetItem.selected = $scope.viewModel.selectAllCheckbox;
        });
    };

    $scope.onSelectCheckbox = function (ruleSetItem) {
        var uncheckedCheckboxes = [];

        if (!ruleSetItem.selected) {
            $scope.viewModel.selectAllCheckbox = false;
        } else {
            uncheckedCheckboxes = _.filter($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
                return !ruleSetItem.selected;
            });

            if (uncheckedCheckboxes.length === 0) {
                $scope.viewModel.selectAllCheckbox = true;
            }
        }
    };

    $scope.onConfirm = function () {
        var ruleSetIds = _.map(_.filter($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
            return ruleSetItem.selected;
        }), 'ruleSetId');

        $scope.$close({
            ruleSetIds: ruleSetIds
        });
    };

    $scope.canEnableConfirmButton = function () {
        var anyRuleSetSelected = false;

        _.each($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
            if (ruleSetItem.selected) {
                anyRuleSetSelected = true;
            }
        });

        return anyRuleSetSelected;
    };

    $scope.$on('modal.closing', function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $scope.onCancel = function () {
        $scope.$dismiss();
    };
};

angular.module('ums.configuration')
    .controller('redeployRuleSetsController', RedeployRuleSetsController);
